import * as React from 'react'
import { safeBoolean } from '../../utils/utils'
import { Badge, badges } from 'DVWebNodeUI'

export interface IXRayBadgeProps {
  isXRay?: boolean
}

export const XRay = ({ isXRay }: IXRayBadgeProps) => (
  safeBoolean(isXRay) && (
    <Badge use={badges.BORDERED_TEXT}>
      <span data-automation-id="x-ray-badge">X-Ray</span>
    </Badge>) || null
)
